export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver al paso de ejecución"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar paso"])},
          "exec_inputs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entradas"])},
          "exec_outputs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Salidas"])},
          "add_exec_input_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir entrada"])},
          "add_exec_output_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Añadir salida"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])},
          "formalized_producer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Productor formalizado"])},
          "formalized_crop_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Campo formalizado"])}
        }
      }
    }
  })
}